import React, { useState, useEffect } from 'react'
import { KTSVG } from '../../_metronic/helpers'

const getDefaultAddresses = () => ([{ id: '', name: '', address: '', isDefault: 'Yes' }])

const AddressForm = (props) => {
    const [addresses, setAddresses] = useState(props.addresses?.length ? props.addresses : getDefaultAddresses())

    useEffect(() => {
        setAddresses(props.addresses?.length ? props.addresses : getDefaultAddresses())
    }, [props.addresses])

    const emitChange = (updatedAddresses) => {
        setAddresses(updatedAddresses)
        props.getAddressesData(updatedAddresses)
    }

    const handleAddressChange = (index, event) => {
        const { name, value } = event.target
        const updatedAddresses = [...addresses]
        updatedAddresses[index] = {
            ...updatedAddresses[index],
            [name]: value,
        }
        emitChange(updatedAddresses)
    }

    const handleDefaultChange = (index) => {
        const updatedAddresses = addresses.map((item, i) => ({
            ...item,
            isDefault: i === index ? 'Yes' : 'No',
        }))
        emitChange(updatedAddresses)
    }

    const addAddressField = () => {
        const updatedAddresses = addresses.concat({
            id: '',
            name: '',
            address: '',
            isDefault: addresses.length === 0 ? 'Yes' : 'No',
        })
        emitChange(updatedAddresses)
    }

    const removeAddressField = (index) => {
        const updatedAddresses = [...addresses]
        const wasDefault = updatedAddresses[index]?.isDefault === 'Yes'
        updatedAddresses.splice(index, 1)

        if (updatedAddresses.length === 0) {
            emitChange(getDefaultAddresses())
            return
        }

        if (wasDefault && !updatedAddresses.some((item) => item.isDefault === 'Yes')) {
            updatedAddresses[0] = { ...updatedAddresses[0], isDefault: 'Yes' }
        }

        emitChange(updatedAddresses)
    }

    return (
        <>
            {addresses.map((item, index) => (
                <div key={index} className="mb-3 border rounded p-2">
                    <div className="input-group mb-2">
                        <span className="input-group-text">Name</span>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="name"
                            placeholder="e.g. Factory, Head Office"
                            value={item.name == null ? '' : item.name}
                            onChange={(event) => handleAddressChange(index, event)}
                        />
                    </div>
                    <div className="input-group mb-2">
                        <span className="input-group-text">Address</span>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="address"
                            placeholder="Full address"
                            value={item.address == null ? '' : item.address}
                            onChange={(event) => handleAddressChange(index, event)}
                        />
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="form-check form-check-custom form-check-solid">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="defaultAddress"
                                id={`default-address-${index}`}
                                checked={item.isDefault === 'Yes'}
                                onChange={() => handleDefaultChange(index)}
                            />
                            <label className="form-check-label ms-2" htmlFor={`default-address-${index}`}>
                                Default
                            </label>
                        </div>
                        <div>
                            {index === addresses.length - 1 && (
                                <button type="button" className="btn btn-icon btn-light btn-active-light-primary btn-sm me-1" onClick={addAddressField}>
                                    <KTSVG path="/media/svg/icons/Navigation/Plus.svg" className="svg-icon svg-icon-5" />
                                </button>
                            )}
                            {addresses.length > 1 && (
                                <button type="button" className="btn btn-icon btn-light btn-active-light-danger btn-sm" onClick={() => removeAddressField(index)}>
                                    <KTSVG path="/media/svg/icons/General/Trash.svg" className="svg-icon svg-icon-5" />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}

export default AddressForm
